import React from "react";
import Container from "../library/Container";
import JobSelect from "./JobSelect";
import FavouriteSelect from "./FavouriteSelect";
import "./JobAddBar.css";

export default ({ onAddJob, onCopyDay, onPasteDay, userId, name, isApproved }) => {
  return (
    <div className={`JobAddBar ${userId ? 'JobAddBar--OtherUser' : ''}`}>
      <Container>
        <div className="JobAddBar__Form">
          <div className="JobAddBar__FormField">
            <JobSelect onChange={onAddJob} userId={userId} name={name} isApproved={isApproved} />
          </div>
          {!userId && (
            <div className="JobAddBar__FormField">
              <FavouriteSelect onChange={onAddJob} isApproved={isApproved} />
            </div>
          )}
          <div className="JobAddBar__Spacer" />
          <button className="JobAddBarBtn" onClick={onCopyDay}>
            Copy
          </button>
          <button disabled={isApproved} className="JobAddBarBtn" onClick={onPasteDay} title={isApproved ? "Unable to add jobs to an approved day" : ""}>
            Paste
          </button>
        </div>
      </Container>
    </div>
  );
};
